import styled from 'styled-components';
import * as Material from '@material-ui/core';
import * as Parent from '../styles';
export const DeclaracaoSubtitle = styled.p `
    font-weight: bold;
    padding-top: 22px;

    > span > span {
        font-weight: normal;
    }
`;

export const ModalBody = styled.div `
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    position: absolute;
    width: 1000px;
    max-width: 90%;
    background-color: white;
    -webkit-box-shadow: 5px 5px 15px 5px #000000; 
    box-shadow: 5px 5px 15px 5px #000000;
    -webkit-border-radius: 10px;
    -moz-border-radius: 10px;
    border-radius: 10px;
    padding: min(20px, 4%) min(85px, 4%);
`;

export const ModalCloseButton = styled(Material.Button)
`
    position: absolute;
    top: 27px;
    right:  min(27px, 5%);;
    -webkit-border-radius: 30px;
    -moz-border-radius: 30px;
    border-radius: 30px;
    height: 65px;
    width: 65px;
`;

export const ModalSessionTitle = styled(Parent.SessionTitle)
`
    margin-top: 30px;
`

export const BoxButtonModal = styled.div `
    width: min(400px, 100%);
`;

export const BannerBloqueioOperacaoEmprestimo = styled.div`
  background-color: #fffbbd;
  padding: 12px 16px;
  margin-top: 16px;
  margin-bottom: 16px;
  text-align: left;
`;

export const SessionTitle = styled.h4`
  margin: 30px 0 30px;
  text-align: left;
`;

export const ValorContribuicoes = styled.h6`
  color: black;
  margin-bottom: 30px;
  font-size: 16px;
  font-weight: bold;
`;

export const Separador = styled.div`
  margin-bottom: 30px;
  clear: both;
  height: 10px;
`;

export const AlinhadorSliderContribuicaoVoluntaria = styled.div`
    margin: 0;
    height: 46px;
`;
export const AlinhadorTotal = styled.div`
    margin-bottom: 60px;
`;